import styled from "styled-components"
import { styled as muiStyled } from '@mui/material/styles';
import { Bold, OverflowTxt, Scroll, Shadow } from "styles/GlobalCss"
import { secondary, white } from "styles/theme"
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Box } from "@mui/material";
import { thirdly2 } from "styles/theme";
import { bg } from "styles/theme";

const WrapDraggable = styled(Draggable)`
width:100% !important;


`

const WrapDroppable = styled(Droppable)`
`

const WrapList = styled.div`
display: flex;
row-gap: 10px;
flex-direction: column;
width:100% !important;
height: 100%;
overflow: auto;
${Scroll};

.drag-and-name{
display:flex;
column-gap:10px;
align-items:center;
width:65%;
}
`

const WrapDragIcon = styled.div`
display:flex;
align-items:center;
background:${bg};
border-radius:8px;
padding:3px;
`

const AssessmentName = styled.div`
${Bold};
${OverflowTxt};
`

const AssessmentSetStyles = muiStyled(Box)(({ theme }) => ({
    height: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    '.create-assessment-btn': {
        height: 30,
        display: "flex",
        justifyContent: "center",
        width: "100%"
    },
    '.footer': {
        height: 330,
        display: "flex",
        flexDirection: "column",
        rowGap: 10,
        alignItems: "center",
        width: "100%",
        justifyContent: "end",
        paddingBottom: 10
    },
    '.semester-and-year-filters': {
        display: "flex",
        flexDirection: "column",
        columnGap: 5,
        width: "100%",
        rowGap: 7,
        justifyContent: "space-between"
    },
    '.title': {
        fontSize: 18,
        fontWeight: "bold"
    },
    '.sub-title': {
        fontSize: 16
    },
    '.header-set': {
        height: 80,
        display: "flex",
        flexShrink: 0,
        alignItems: "center",
        flexDirection: "column",
        rowGap: 10,
        justifyContent: "center"
    }
}));


const WrapSectionList = styled.div`
height:100%;
width:100%;
overflow: auto;
display: flex;
flex-grow: 1;
`

const WrapItem = styled.li`

`

const Title = styled.div`
font-size:18px;
${Bold};
`

const WrapSetHeader = styled.div`
height: 70px;
display: flex;
flex-shrink: 0;
align-items: center;

`

const AssessmentItem = styled.div`
background: ${white};
padding: 15px;
border-radius: 8px;
justify-content: space-between;
display: flex;

${Shadow};
`

const WrapCreateSet = styled.div`
height: 100%;
overflow:auto;
${Scroll};
`

const WrapContent = styled.div`
display: grid;
grid-template-columns: auto 300px;
column-gap: 10px;
height: 100%;
flex-grow:1;
overflow:auto;
`

const WrapAssessmentDefs = styled.div`
display: flex;
flex-direction: column;
row-gap: 8px;
height: 100%;
overflow:auto;
${Scroll};
`

const WrapFooterBtns = styled.div`
height: 30px;
display:flex;
flex-direction:column;
justify-content:center;
width:100%;
`

const WrapFooter = styled.div`
height:70px;
display:flex;
align-items:center;
width:100%;
`

export { WrapFooter, WrapFooterBtns, AssessmentName, Title, WrapDroppable, WrapDraggable, WrapSectionList, WrapList, AssessmentSetStyles, WrapItem, WrapSetHeader, WrapAssessmentDefs, WrapContent, WrapCreateSet, AssessmentItem, WrapDragIcon }